/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Clikr - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Hashology
  Author URL: http://www.hashology.io
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)


// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// API Calls
import './http/requests'

// mock
import './fake-db/index.js'

// Theme Configurations
import '../themeConfig.js'


// Firebase
import '@/firebase/firebaseConfig'


// Auth0 Plugin
import AuthPlugin from './plugins/auth'
Vue.use(AuthPlugin)


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Clikr Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

// Algolia Instantsearch
import InstantSearch from 'vue-instantsearch'
Vue.use(InstantSearch)

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'AIzaSyB4DDathvvwuwlwnUu7F4Sow3oU22y5T1Y',
    libraries: 'places' // This is required if you use the Auto complete plug-in
  }
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// VueObserveVisibility
import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// Loading Methods Mixin
Vue.mixin({
  data () {
    return {
      loading: []
    }
  },
  computed: {
    // this is needed in order for the watcher to see new and old values
    computedLoading () {
      return this.loading
    }
  },
  watch: {
    computedLoading (newVal, oldVal) {
      if (newVal === oldVal) {
        return null
      }
      if (oldVal > 0 && newVal > 0) {
        return null
      }
      if (oldVal === 0 && newVal > 0) {
        this.startLoading()
      }
      if (oldVal > 0 && newVal === 0) {
        this.endLoading()
      }
    }
  },
  methods: {

    startLoading () {
      this.$vs.loading({
        background: 'rgba(255,255,255,.7)',
        color: 'rgb(var(--vs-primary))'
      })
    },
    endLoading () {
      this.$vs.loading.close()
    }
  }
})


// Mixin for router referrer
Vue.mixin({
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      if (vm.$router) {
        vm.$router.referer = from
      }
    })
  },
  beforeRouteUpdate (to, from, next) {
    if (this.$router) {
      this.$router.referer = from
    }
    next()
  }
})


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
}).$mount('#app')
